<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="32" height="32" rx="7" fill={primary600} />
  <path
    d="M24.4493 11.7383L16.8769 19.3107L12.8913 15.3252L6.91309 21.3035"
    stroke={primary200}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M19.6675 11.7383H24.4501V16.5209"
    stroke={primary200}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
